import React from 'react';
import SEO from '../components/SEO';

const About = () => {
  return (
    <>
    <SEO 
        title="About Franklin | Full Stack Developer & Graphic Designer"
        description="Learn more about Franklin Fernandez, a full stack developer with 17+ years of experience in UI/UX, PHP, Laravel, and graphic design."
        keywords="about franklin, developer experience, graphic design portfolio"
      />
    <main>
      <section id="home" className="breadcrumb-section">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12">
              <div className="content d-flex flex-column justify-content-between">
                <div className="heading w-60">
                  <h1 className="title">Crafting <img loading="lazy" alt="Franklin" src="/assets/img/franklin.webp" /></h1>
                  <div className="flex ms-auto"><span className="line animate-line my-3 my-md-0"></span>
                    <h1 className="title">timeless stories.</h1>
                  </div>
                </div>
                <p className="lead w-50 mt-4 ms-auto">I transform ideas into impactful digital experiences, delivering innovative solutions that elevate brands and captivate audiences around the world.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="experiences sticky primary-bg">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-12 col-lg-3">
              <div className="intro">
                <h3 className="title">Experiences</h3>
              </div>
            </div>
            <div className="col-12 col-lg-8">
              <div className="row items">
                <div className="col-12 col-md-6 item">
                  <div className="content"><span className="count">01.</span>
                    <h4 className="title mt-0 mb-3">Creative Labs</h4>
                    <h6 className="position my-3">Sr. Web Developer &amp; Designer</h6>
                    <span className="badge text-bg-light">Jan 2024 - Present</span>
                    <p className="mt-3">At Creative Labs, I lead a team of designers and developers to deliver high-quality digital products. My role involves overseeing the entire development process.</p>
                  </div>
                </div>
                {/* Other experience items omitted for brevity */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="primary-bg p-0">
        <img loading="lazy" className="img-fluid" alt="Franklin's Case Study" src="/assets/img/case-1.webp" />
      </section>

      <section className="awards skills sticky primary-bg">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-12 col-lg-3">
              <div className="intro">
                <h3 className="title">Crafting Unique Skills</h3>
              </div>
            </div>
            <div className="col-12 col-lg-8">
              <div className="row items">
                {/* Skills items omitted for brevity */}
              </div>
            </div>
          </div>
          <hr />
          <div className="row justify-content-between">
            <div className="col-12 col-lg-3">
              <div className="intro">
                <h3 className="title">Awards &amp; Recognition</h3>
              </div>
            </div>
            <div className="col-12 col-lg-8">
              <div className="row items">
                {/* Awards items omitted for brevity */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="faq">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <div className="intro">
                <h3 className="title">Frequently Asked Questions</h3>
              </div>
            </div>
          </div>
          <div className="row justify-content-center mt-4">
            <div className="col-12 col-md-10">
              <div className="accordion accordion-flush" id="brilio-accordion">
                <div className="accordion-item">
                  <h4 className="accordion-header"><button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1">What services do you offer?</button></h4>
                  <div id="collapse1" className="accordion-collapse collapse show" data-bs-parent="#brilio-accordion">
                    <div className="accordion-body">I offer a range of services including web design, branding, digital marketing, UI/UX design etc. Each project is tailored to meet your unique needs and goals.</div>
                  </div>
                </div>
                {}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta border-top border-light-subtle">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-12 col-md-10 col-lg-7">
              <h2 className="title mb-0 mb-md-2">Let's Create Something</h2>
              <div className="cta-text">
                <span className="line-item h2">Together</span>
                <span className="line"></span>
                <a href="mailto:fernandez954@gmail.com" className="btn btn-dark">Get In Touch!<i className="icon bi bi-arrow-right ms-1"></i>
                  <span></span>
                </a>
              </div>
              <div className="socials mt-5">
                <nav className="nav justify-content-center">
                  <a className="nav-link swap-icon" href="/#">Instagram
                    <i className="icon rotate bi bi-arrow-right-short"></i>
                  </a>
                  <a className="nav-link swap-icon" href="/#">Twitter
                    <i className="icon rotate bi bi-arrow-right-short"></i>
                  </a>
                  <a className="nav-link swap-icon" href="/#">LinkedIn
                    <i className="icon rotate bi bi-arrow-right-short"></i>
                  </a>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
}

export default About;